import SupportResponse from "./SupportResponse";

export default SupportResponse;
